<template>
  <el-col :span="colspan" id="info-col" class="h-padded left-aligned-col">
    <el-row type="flex" align="middle" justify="start">
      <el-col :span="0" style="margin-right: 12px;">
        <h2 style="font-weight: 100; display: inline-block;">{{ title }}</h2>
      </el-col>
      <el-col :span="0" class="stats">
        <p v-if="meta && meta.count">{{ meta.count ? `${meta.count} results` : 'No results' }} </p>
      </el-col>
      <el-col :span="0" class="stats">
        <p v-if="meta && meta.count">{{ meta.shown ? `${meta.shown} shown` : '' }}</p>
      </el-col>
      <el-col :span="0" class="stats">
        <el-tag v-if="selection && selection.length" type="primary">{{ selection.length }} selected</el-tag>
      </el-col>
    </el-row>
  </el-col>
</template>

<script>
  export default {
    name: 'headerInfoText',
    props: {
      colspan: {
        'type': Number,
        'required': false,
        'default': 9
      },
      title: {
        'type': String,
        'required': true
      },
      meta: {
        'type': Object,
        'required': false
      },
      selection: {
        'type': Array,
        'required': false
      }
    }
  }
</script>

<style scoped>
  .h-padded {
    padding: 0 12px;
  }
  .left-aligned-col {
    text-align: left;
  }
  .stats {
    padding: 0 6px;
  }
  .stats p{
    margin: 0;
  }
  #info-col h2 {
    margin: 12px 0;
  }
</style>



// WEBPACK FOOTER //
// src/components/HeaderInfoText.vue